import { GET_SHELVES } from "constants/shelves";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_SHELVES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
